import {
  ToastType,
  dismissChartToast,
  showChartToast
} from "components/charts/components/ChartToast";

export const TOAST_TRIGGERS = {
  NORMALIZE: "normalize",
  SELECT: "select",
  SAVE: "save"
} as const;

export type ToastTrigger = (typeof TOAST_TRIGGERS)[keyof typeof TOAST_TRIGGERS];

const handleTypeWellMissingNormalizationToast = (
  chartId: string,
  numberOfTypeWellsMissingNormalization: number,
  trigger?: ToastTrigger
) => {
  const toastId = `type-well-missing-normalization-${chartId}`;

  if (numberOfTypeWellsMissingNormalization > 0 && trigger) {
    const message = `${numberOfTypeWellsMissingNormalization} type well${
      numberOfTypeWellsMissingNormalization > 1 ? "s" : ""
    } without normalization data ${
      numberOfTypeWellsMissingNormalization > 1 ? "were" : "was"
    } removed from the chart.`;

    showChartToast(chartId, message, ToastType.Warning, { toastId });
  } else if (numberOfTypeWellsMissingNormalization === 0) {
    // Always dismiss if no missing normalization, regardless of trigger
    dismissChartToast(chartId, toastId);
  }
};

export default handleTypeWellMissingNormalizationToast;
